/**
 * Library LazyLoader
 * Created 12.05.22
 *
 * @author Christoph Ehlers <ce@construktiv.de> | Construktiv GmbH
 */
export default class LazyLoader {
  listen(){
    const lazyImages = [].slice.call(document.querySelectorAll(".lazy-image"));

    if ("IntersectionObserver" in window) {
      let lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) =>{
          if (entry.isIntersecting) {
            this.onIntersect(entry.target);
            lazyBackgroundObserver.unobserve(entry.target);
          }
        });
      });

      lazyImages.forEach(function(lazyBackground) {
        lazyBackgroundObserver.observe(lazyBackground);
      });
    }
  }
  onIntersect(intersectionElement){
    const type = intersectionElement.dataset.lazyType || (intersectionElement.tagName.toLowerCase()==='img'?'src':'');
    const lazySrc = intersectionElement.dataset.lazySrc;

    switch(type.toLowerCase()){
      case 'backgroundimage':
        intersectionElement.style.backgroundImage="url('"+lazySrc+"')";
        break;
      case 'src':
        intersectionElement.src=lazySrc;
        break;
      default:
        console.log('unknown lazy-type',type);
    }
  }
}